import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  SimpleChange,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BetSlipPickedDTO } from '../model/lottomart-model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'single-number-picker',
  template: `
    <svg
      id="{{ 'btn_ball_' + getPickValue() }}"
      tappable
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 52 54">
      <g>
        @if (type === 'STAR') {
          <polygon
            [style.fill]="getFillColor()"
            [style.stroke]="getStrokeColor()"
            points="24.536,42.429 10.043,46.752 9.647,31.536 1.087,18.992 15.335,13.91 24.536,1.833 33.738,13.91 47.984,18.992 39.424,31.536 39.028,46.752" />
        }
        @if (type === 'CIRCLE') {
          <circle
            class="ball-width"
            [style.fill]="getFillColor()"
            [style.stroke]="getStrokeColor()"
            cx="25"
            cy="26"
            r="23.6" />
        }
        @if (type === 'SQUARE') {
          <rect
            class="ball-width"
            [style.fill]="getFillColor()"
            [style.stroke]="getStrokeColor()"
            width="45"
            height="45" />
        }

        @if (type !== 'SQUARE') {
          <text [ngStyle]="getTextStyle()" class="ball-square" text-anchor="middle" x="24" y="33">
            {{ getPickValue() }}
          </text>
        }

        @if (type === 'SQUARE') {
          <text [ngStyle]="getTextStyle()" class="ball-square" text-anchor="middle" x="22" y="31">
            {{ getPickValue() }}
          </text>
        }

        @if (!readonly) {
          <foreignObject height="50px" width="50px" x="0" y="0">
            <xhtml:input
              class="svg-input"
              type="text"
              (blur)="onBlurMethod($event)"
              [(ngModel)]="pickValue"></xhtml:input>
          </foreignObject>
        }
      </g>
    </svg>
  `,
  styleUrls: ['single-number-pickers.scss'],
  standalone: false,
})
export class SingleNumberPickerComponent implements OnInit {
  @Input() pick: BetSlipPickedDTO;

  @Input() type: string;

  @Input() isDisplayLine: boolean;

  @Input() readonly: boolean;

  @Input() nonSelectedStrokeColor: string;

  @Input() nonSelectedFillColor: string;

  @Input() nonSelectedTextColor: string;

  @Input() selectedStrokeColor: string;

  @Input() selectedFillColor: string;

  @Input() selectedTextColor: string;

  @Input() placeholderFillColor: string;

  @Input() placeholderStrokeColor: string;

  @Input() placeholderTextColor: string;

  @Input() selectionPlaceholderFillColor: string;

  @Input() selectionPlaceholderStrokeColor: string;

  @Input() selectionPlaceholderTextColor: string;

  @Input() optionType: string;

  @Output() valueChanged = new EventEmitter<BetSlipPickedDTO>();

  pickValue: any;

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    if (this.pick.isNumber) {
      this.pickValue = this.pick.value;
    } else {
      this.pickValue = this.pick.strValue;
    }
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes['pick'] !== undefined && this.pick !== undefined) {
      if (changes['pick']['id'] === this.pick.id) {
        if (this.pick.isNumber) {
          this.pickValue = this.pick.value;
        } else {
          this.pickValue = this.pick.strValue;
        }
      }
    }
  }

  refresh(pick: BetSlipPickedDTO) {
    if (this.pick.id === pick.id) {
      this.pick = pick;
      this.changeDetectorRef.detectChanges();
    }
  }

  getPickValue() {
    if (this.pick.isNumber) {
      return this.pick.value;
    } else {
      return this.pick.strValue;
    }
  }

  onBlurMethod(event: Event) {
    if (this.pick.isNumber) {
      this.pick.value = Number((event.target as HTMLInputElement).value);
    } else {
      this.pick.strValue = (event.target as HTMLInputElement).value;
    }
    this.valueChanged.emit(this.pick);
  }

  getFillColor() {
    if (this.isDisplayLine && !this.pick.picked) {
      return this.placeholderFillColor;
    }
    if (this.isDisplayLine) {
      if (this.pick.inResult === true) {
        if (this.optionType === 'JOLLY') {
          return this.pick.picked ? '#ed5565' : this.placeholderFillColor;
        }
        return this.pick.picked ? this.selectedFillColor : this.placeholderFillColor;
      }
      if (this.pick.isJolly === true || this.optionType === 'JOLLY') {
        // return this.pick.picked ? this.selectedFillColor : this.placeholderFillColor;
        return this.pick.picked ? '#fff' : this.placeholderFillColor;
      }
      return this.pick.picked ? this.selectionPlaceholderFillColor : this.placeholderFillColor;
    }
    return this.pick.picked ? this.selectedFillColor : this.nonSelectedFillColor;
  }

  getStrokeColor() {
    if (this.pick.value === undefined) {
      // yes, fill shape with stroke color if no value exists
      return this.placeholderStrokeColor;
    }
    if (this.isDisplayLine) {
      if (this.pick.inResult === true) {
        if (this.optionType === 'JOLLY') {
          return this.pick.picked ? '#edbabf' : this.placeholderStrokeColor;
        }
        return this.pick.picked ? this.selectionPlaceholderStrokeColor : this.placeholderStrokeColor;
      }
      if (this.pick.isJolly === true || this.optionType === 'JOLLY') {
        return this.pick.picked ? '#edbabf' : this.placeholderStrokeColor;
      }
      return this.pick.picked ? this.selectionPlaceholderStrokeColor : this.placeholderStrokeColor;
    }
    return this.pick.picked ? this.selectedStrokeColor : this.nonSelectedStrokeColor;
  }

  getTextStyle() {
    if (this.isDisplayLine) {
      if (this.pick.inResult === true) {
        if (this.optionType === 'JOLLY') {
          return this.pick.picked
            ? { fill: this.selectedTextColor, 'font-family': 'Figtree-Bold' }
            : { fill: this.placeholderTextColor, 'font-family': 'Figtree-Regular' };
        }
        return this.pick.picked
          ? { fill: this.selectedTextColor, 'font-family': 'Figtree-Bold' }
          : { fill: this.placeholderTextColor, 'font-family': 'Figtree-Regular' };
      }
      if (this.pick.isJolly === true || this.optionType === 'JOLLY') {
        return this.pick.picked
          ? { fill: '#ed5565', 'font-family': 'Figtree-Bold' }
          : { fill: this.placeholderTextColor, 'font-family': 'Figtree-Regular' };
      }
      return this.pick.picked
        ? { fill: this.selectionPlaceholderTextColor, 'font-family': 'Figtree-Bold' }
        : { fill: this.placeholderTextColor, 'font-family': 'Figtree-Regular' };
    }
    return this.pick.picked
      ? { fill: this.selectedTextColor, 'font-family': 'Figtree-Bold' }
      : { fill: this.nonSelectedTextColor, 'font-family': 'Figtree-Regular' };
  }
}
